var _rect, _g, _rect2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2176_3010)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2176_3010)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.75 14.5C19.8772 14.5 20.9582 14.9478 21.7552 15.7448C22.5522 16.5418 23 17.6228 23 18.75V23H18.75C17.6228 23 16.5418 22.5522 15.7448 21.7552C14.9478 20.9582 14.5 19.8772 14.5 18.75C14.5 17.6228 14.9478 16.5418 15.7448 15.7448C16.5418 14.9478 17.6228 14.5 18.75 14.5ZM18.75 25H23V29.25C23 30.0906 22.7507 30.9123 22.2837 31.6112C21.8168 32.3101 21.153 32.8548 20.3764 33.1765C19.5998 33.4982 18.7453 33.5823 17.9209 33.4183C17.0964 33.2543 16.3392 32.8496 15.7448 32.2552C15.1504 31.6608 14.7457 30.9036 14.5817 30.0791C14.4177 29.2547 14.5018 28.4002 14.8235 27.6236C15.1452 26.847 15.6899 26.1832 16.3888 25.7163C17.0877 25.2493 17.9094 25 18.75 25ZM29.25 14.5C30.3772 14.5 31.4582 14.9478 32.2552 15.7448C33.0522 16.5418 33.5 17.6228 33.5 18.75C33.5 19.8772 33.0522 20.9582 32.2552 21.7552C31.4582 22.5522 30.3772 23 29.25 23H25V18.75C25 17.6228 25.4478 16.5418 26.2448 15.7448C27.0418 14.9478 28.1228 14.5 29.25 14.5ZM25 25H29.25C30.0906 25 30.9123 25.2493 31.6112 25.7163C32.3101 26.1832 32.8548 26.847 33.1765 27.6236C33.4982 28.4002 33.5823 29.2547 33.4183 30.0791C33.2544 30.9036 32.8496 31.6608 32.2552 32.2552C31.6608 32.8496 30.9036 33.2543 30.0791 33.4183C29.2547 33.5823 28.4002 33.4982 27.6236 33.1765C26.847 32.8548 26.1833 32.3101 25.7163 31.6112C25.2493 30.9123 25 30.0906 25 29.25V25Z",
    fill: "#6E51E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.75 14.5C19.8772 14.5 20.9582 14.9478 21.7552 15.7448C22.5522 16.5418 23 17.6228 23 18.75V23H18.75C17.6228 23 16.5418 22.5522 15.7448 21.7552C14.9478 20.9582 14.5 19.8772 14.5 18.75C14.5 17.6228 14.9478 16.5418 15.7448 15.7448C16.5418 14.9478 17.6228 14.5 18.75 14.5ZM18.75 25H23V29.25C23 30.0906 22.7507 30.9123 22.2837 31.6112C21.8168 32.3101 21.153 32.8548 20.3764 33.1765C19.5998 33.4982 18.7453 33.5823 17.9209 33.4183C17.0964 33.2543 16.3392 32.8496 15.7448 32.2552C15.1504 31.6608 14.7457 30.9036 14.5817 30.0791C14.4177 29.2547 14.5018 28.4002 14.8235 27.6236C15.1452 26.847 15.6899 26.1832 16.3888 25.7163C17.0877 25.2493 17.9094 25 18.75 25ZM29.25 14.5C30.3772 14.5 31.4582 14.9478 32.2552 15.7448C33.0522 16.5418 33.5 17.6228 33.5 18.75C33.5 19.8772 33.0522 20.9582 32.2552 21.7552C31.4582 22.5522 30.3772 23 29.25 23H25V18.75C25 17.6228 25.4478 16.5418 26.2448 15.7448C27.0418 14.9478 28.1228 14.5 29.25 14.5ZM25 25H29.25C30.0906 25 30.9123 25.2493 31.6112 25.7163C32.3101 26.1832 32.8548 26.847 33.1765 27.6236C33.4982 28.4002 33.5823 29.2547 33.4183 30.0791C33.2544 30.9036 32.8496 31.6608 32.2552 32.2552C31.6608 32.8496 30.9036 33.2543 30.0791 33.4183C29.2547 33.5823 28.4002 33.4982 27.6236 33.1765C26.847 32.8548 26.1833 32.3101 25.7163 31.6112C25.2493 30.9123 25 30.0906 25 29.25V25Z",
    fill: "url(#paint0_linear_2176_3010)",
    fillOpacity: 0.24
  })))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 23.5,
    stroke: "#F4F5FA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2176_3010",
    x1: 24,
    y1: 14.5,
    x2: 24,
    y2: 33.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2176_3010"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(8 8)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2176_3010"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/Icon1.52127e99b6fd140edaae0e48c68c8944.svg";
export { ForwardRef as ReactComponent };